import { toast } from 'react-toastify';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_ALLOTVEHICLE,
  GET_AVAILABLESUPPLIERS,
  GET_AVAILABLEVEHICLE,
} from 'resources/actionTypes';
import {
  allotVehicle,
  availableSupplierService,
  availableVehicleService,
} from 'services/OperationService';
import store from 'redux/store';
import { onLoaderTrigger } from "redux/actions/CommonAction";
import { getTrip } from 'redux/actions/UserTrip';
import { getDriver } from 'redux/actions/UserDriver';

function* putAllotVehicle(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const allotedDetails = yield call(allotVehicle, payload?.trip);
  if (allotedDetails.success) {
    yield put({
      type: GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_SUCCESS,
      allotedDetails: allotedDetails,
    });
    toast.success(allotedDetails?.message || 'Alloting Vehicle Successfully');
    store.dispatch(onLoaderTrigger(false));

    if(payload?.userUpdateAssignDriver?.rideTrip){
        store.dispatch(getTrip({ page: "", pageSize: "", status: payload?.userUpdateAssignDriver?.status, type: '', id:payload?.userUpdateAssignDriver?.tripId }));
        store.dispatch(getDriver(payload?.userUpdateAssignDriver?.driverData))
      }else{
       store.dispatch(getTrip({ page: "", pageSize: "", status: payload?.userUpdateAssignDriver?.status, type: '' }));
       store.dispatch(getDriver(payload?.userUpdateAssignDriver?.driverData))
      }
  } else {
    yield put({
      type: GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_FAILED,
      message: allotedDetails.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(allotedDetails?.message || 'Alloting Vehicle Failed');
  }
}

export function* allotVehicleSaga() {
  yield takeEvery(GET_ALLOTVEHICLE.GET_ALLOTVEHICLE_REQUESTED, putAllotVehicle);
}

function* getAvailablevehicle(action) {
  const payload = action.payload || {};
  const availableVehicleDetails = yield call(availableVehicleService, payload);

  if (availableVehicleDetails.success) {
    yield put({
      type: GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_SUCCESS,
      availableVehicle: availableVehicleDetails,
    });
  } else {
    yield put({
      type: GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_FAILED,
      message: availableVehicleDetails.message,
    });
      toast.error(availableVehicleDetails?.message || 'Failed to fetch Vehicle');
  }
}

export function* getAvailablevehicleSaga() {
  yield takeEvery(
    GET_AVAILABLEVEHICLE.GET_AVAILABLEVEHICLE_REQUESTED,
    getAvailablevehicle
  );
}

function* getAvailableSuppliers(action) {
  const payload = action.payload || {};
  const availableSuppliersDetails = yield call(
    availableSupplierService,
    payload
  );

  if (availableSuppliersDetails.success) {
    yield put({
      type: GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_SUCCESS,
      availableSuppliers: availableSuppliersDetails,
    });
  } else {
    yield put({
      type: GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_FAILED,
      message: availableSuppliersDetails.message,
    });
      toast.error(availableSuppliersDetails?.message || 'Failed to fetch Suppliers');
  }
}

export function* getAvailableSupplierSaga() {
  yield takeEvery(
    GET_AVAILABLESUPPLIERS.GET_AVAILABLESUPPLIERS_REQUESTED,
    getAvailableSuppliers
  );
}